import { HttpParams } from '@angular/common/http'
import { BaseWithId, PaginatedList, PaginatedSearchCriteria } from './base.model'
import { TimesheetProject } from './timesheet-project.model'

export class Client extends BaseWithId {
    static clientNotYetDefined = 'CLIENT NOT YET DEFINED'

    name!: string
    timesheetProjects!: Array<TimesheetProject>

    static fromJSON(json: any): Client {
        const result: Client = Object.create(Client.prototype)

        return {
            ...result,
            ...json,
            timesheetProjects: json.timesheetProjects
                ? json.timesheetProjects.map((item: any) => TimesheetProject.fromJSON(item))
                : null
        }
    }
}

export class ClientSearchCriteria extends PaginatedSearchCriteria {
    name?: string
    includeArchived?: boolean

    constructor(page?: number, pageSize?: number, name?: string, includeArchived?: boolean) {
        super(page, pageSize)
        this.name = name
        this.includeArchived = includeArchived
    }

    httpParams(): HttpParams {
        let params = super.httpParams()
        if (this.name !== undefined) {
            params = params.set('name', this.name)
        }
        if (this.includeArchived) {
            params = params.set('includeArchived', `${this.includeArchived}`)
        }

        return params
    }
}

export class ClientPaginatedList extends PaginatedList<Client> {
    static fromJSON(json: any): ClientPaginatedList {
        const result: ClientPaginatedList = Object.create(ClientPaginatedList.prototype)

        return { ...result, ...json, items: json.items ? json.items.map((item: any) => Client.fromJSON(item)) : null }
    }
}
